<script>
  import { mapState } from 'vuex'
  export default {
    name: 'SignupProgress',
    props: ['step'],
    computed: {
      model: {
        get() {
          return this.$store.state[this.form][this.field]
        },
        set(v) {
          this.$store.dispatch('signup/SET_FIELD', { key: this.field, value: v })
        },
      },
    },
  }
</script>

<template>
  <v-row justify="center">
    <v-col class="pa-0 ma-0" cols="12" md="6" lg="6">
      <div class="step-indicator" :class="[step >= 0 ? 'activestep' : '']">
        Pet Details
      </div>
      <div class="step-indicator" :class="[step >= 1 ? 'activestep' : '']">
        Owner Details
      </div>
      <div class="step-indicator" :class="[step >= 2 ? 'activestep' : '']">
        Payment
      </div>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>
.step-indicator {
  display: inline-block;
  border-top: solid 3px #E2E2E2;
  color: #aaa;
  font-size: 12px;
  padding: 8px 15px 0;
}
.activestep {
  border-top-color: $hpp-green;
  color: #333;
}
</style>
